import { ISpecificationGroup } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useIsMobile } from "@/hooks/useIsMobile";
import PcTabs from "./PcTabs";
import ProdDetails from "./ProdDetails";
import ProdSpec from "./ProdSpec";
import { Row } from "@/app/components/lib/my-bootstrap";
import Separator from "@/app/components/lib/Separator";
import { useTranslation } from "@/hooks/localization/useTranslations";
import ProductDetailsReview from "../ProductDetailsReview";
import { Ratings } from "@/api/AppApi/services/home/interfaces/IProduct";

type Props = {
  html: any;
  spec: ISpecificationGroup[];
  showRate: boolean;
  rate: number;
  ratings: Ratings;
  productId: number;
  canReview: boolean;
};

const DetailsSpec: React.FC<Props> = ({
  html,
  spec,
  showRate,
  rate,
  ratings,
  productId,
  canReview,
}) => {
  const t = useTranslation();
  const mobile = useIsMobile();
  const isSpec = !!spec && spec.length > 0;
  const activeTabs = [!!html, isSpec, showRate];
  const activeTabsLen = activeTabs.filter((tab) => tab === true).length;
  const viewPCTabs = !mobile && activeTabsLen > 1;
  const mClass = mobile ? "-mobile" : "";
  return (
    <div>
      {viewPCTabs ? (
        <Row className="m-0 product-details-container">
          <PcTabs
            html={html}
            spec={spec}
            showRate={showRate}
            rate={rate}
            ratings={ratings}
            productId={productId}
            canReview={canReview}
          />
        </Row>
      ) : (
        <>
          {html && (
            <>
              <Separator secondary={mobile} startLabel={t.product_details} />
              <div
                style={mobile ? { padding: 16 } : {}}
                className={`m-0 product-details-container${mClass}`}
              >
                <ProdDetails html={html} />
              </div>
            </>
          )}
          {isSpec && (
            <>
              <div style={{ marginBottom: 24 }} />
              <Separator secondary={mobile} startLabel={t.specifications} />
              <div className={`m-0 product-details-container${mClass}`}>
                <ProdSpec spec={spec} />
              </div>
            </>
          )}
          {showRate && (
            <ProductDetailsReview
              rate={rate}
              ratings={ratings}
              productId={productId}
              canReview={canReview}
              mobile={true}
            />
          )}
        </>
      )}
    </div>
  );
};

export default DetailsSpec;
